import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OrdersService {
  constructor(private http: HttpClient) {}

  placeOrder(data) {
    return this.http
      .post(`${environment.apiUrl}/order/place-order`, data)
      .pipe();
  }

  getAllOrders(data) {
    return this.http.post(`${environment.apiUrl}/orders/all`, data).pipe();
  }

  setOrderStatus(id, status) {
    return this.http
      .get(`${environment.apiUrl}/order/${id}/set-status/${status}`)
      .pipe();
  }

  setOrderAssignedTo(id, assigned_to) {
    return this.http
      .get(`${environment.apiUrl}/order/${id}/set-assigned-to/${assigned_to}`)
      .pipe();
  }

  deleteOrder(id) {
    return this.http.delete(`${environment.apiUrl}/order/${id}`).pipe();
  }

  getAnalytics(data) {
    return this.http
      .post(`${environment.apiUrl}/orders/analytics`, data)
      .pipe();
  }

  getNominatimAddress(latitude, longitude): Promise<any> {
    return firstValueFrom(
      this.http.get(
        `https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`,
      ),
    );
  }

  getNearestBranchShippingCost(data) {
    return this.http
      .post(`${environment.apiUrl}/order/nearest-branch-shipping-cost`, data)
      .pipe();
  }
}
